<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
  import SimpleClickEvent from './components/common/SimpleClickEvent.vue'

  export default {
    name: 'App',
    components: {
      SimpleClickEvent
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue